
import { useCurrencyStore } from '@/store/currency'

const currency = useCurrencyStore()


/* 货币类型 */
const CtCurrencyMap: Map<string, string> = new Map();
currency.getList.forEach((item: SelectItem) => {
    CtCurrencyMap.set(item.value, item.name);
});

export const GetCurrency = (key: string) => {
    return CtCurrencyMap.get(key) || "其他"
}


/* 订立来源 */
const CtSourceMap: Map<string, string> = new Map();
CtSourceMap.set("0", '未知类型');
CtSourceMap.set('ZB', '招标');
CtSourceMap.set('BCHT', '补充合同');
CtSourceMap.set('LXHT', '续签合同');
CtSourceMap.set('QT', '其他');

export const GetSourceType = (key: string) => {
    return CtSourceMap.get(key) || "未知类型"
}

export interface MapConfig {
    text: string
    color: string
}

/* 相对方类型 */
const CgPartTypeMap: Map<string, MapConfig> = new Map();
CgPartTypeMap.set("1", { text: "内部单位", color: "warning" })
CgPartTypeMap.set("2", { text: "供应商", color: "primary" })
CgPartTypeMap.set("3", { text: "客户", color: "primary" })
CgPartTypeMap.set("4", { text: "合作伙伴", color: "success" })
CgPartTypeMap.set("99", { text: "其他", color: "info" })



export const GetPartType = (key: string) => {
    return CgPartTypeMap.get(key) || { text: "其他", color: "#E6A23C" }
}

/* 文件类型 */
const FileTypesMap: Map<string, string> = new Map();
FileTypesMap.set("65CAF56C-0CD8-49C2-ACA5-A5B8FE4DB3CE", '合同正文');
FileTypesMap.set('D647F9B7-F230-4BF0-9766-F295FFA32AF0', '其他');

export const GetFileType = (key: string) => {
    return FileTypesMap.get(key) || "未知类型"
}